import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../components/featured-posts";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

interface FoodSectionProps {
  foodData: dataListsType[];
  nation: string;
}

const FoodSection = ({ nation, foodData }: FoodSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-xs font-semibold pt-2 pb-2 tracking-widest flex justify-between">
        <span>{nation} Food</span>
        <Link
          className="font-bold text-[#4d5bcc]"
          to={{
            pathname: "/morepage",
            search: `?category=Food&nation=${encodeURIComponent(
              nation
            )}&label=${encodeURIComponent(`${nation} Food`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-14 h-[3px] bg-black"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight props={foodData.slice(0, 2)} />
    </div>
  </div>
);

export default function Food() {
  const [foodData, setFoodData] = useState<{
    China: dataListsType[];
    Japan: dataListsType[];
    Indonesia: dataListsType[];
    // Singapore: dataListsType[];
  }>({
    China: [],
    Japan: [],
    Indonesia: [],
    // Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Food");
    setFoodData({
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      // Singapore: allData.filter((item) => item.nation === "Singapore"),
      China: allData.filter((item) => item.nation === "China"),
      Japan: allData.filter((item) => item.nation === "Japan"),
    });
  }, []);

  return (
    <>
      <Header />
      <Navbar />
      <AdPage />
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center max-w-[888px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Food</h1>
          {Object.entries(foodData).map(([nation, data]) => (
            <FoodSection key={nation} nation={nation} foodData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
